import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

import { ZIndex } from "../../../../shared/constants";

export const CreateApiPageContainer = styled.div`
    margin: 0 auto;
    padding: ${Spacing.LG}px ${Spacing.LG}px;
`;

export const Footer = styled.div`
    position: sticky;
    z-index: ${ZIndex.ApiStepperFooter};
    bottom: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 55px;
    padding: ${Spacing.SM}px;

    background-color: white;
    box-shadow: 0 ${Spacing.SM}px 20px rgba(0, 0, 0, 8%);
`;

export const pageSectionHeight = css`
    width: 100%;
`;

export const PageSectionContainer = styled.div`
    position: relative;

    width: 100%;
    height: 100%;
    margin: auto;
    padding: ${Spacing.XL}px 0;
`;
